module.exports = __webpack_public_path__ + "static/media/iPhone14-2.e89c4407.png";